import { useCallback } from "react"

import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import type { ReportSettingsPatch } from "../helpers/reportSettings.ts"
import { updateReportSettings } from "../redux/reports.thunks.ts"

/**
 * Submit handler for `ReportSettingsModal`, shared by its two hosts.
 *
 * The modal has to know whether the save landed so it can keep the typed values
 * on screen after a rejection, and `mapDispatchToProps` cannot report that — so
 * the `useAppDispatch` escape hatch lives here instead of in each container.
 */
export const useReportSettingsSubmit = (reportId?: string) => {
  const dispatch = useAppDispatch()

  return useCallback(
    async (patch: ReportSettingsPatch) => {
      if (!reportId) return true
      const action = await dispatch(
        updateReportSettings({ id: reportId, patch })
      )
      return updateReportSettings.fulfilled.match(action)
    },
    [dispatch, reportId]
  )
}
